import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper height100" }
const _hoisted_2 = { class: "d-flex justify-center my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      fluid: "",
      class: "height100"
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "py-8 my-4" }, [
          _createElementVNode("p", null, [
            _createElementVNode("b", null, "本人確認用の認証メールを送信しました。")
          ]),
          _createElementVNode("br"),
          _createElementVNode("p", null, "以下の手順でログインしてください。"),
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", { style: {"vertical-align":"top"} }, "１．"),
                _createElementVNode("td", { style: {"vertical-align":"top"} }, [
                  _createTextVNode("メール内の"),
                  _createElementVNode("b", null, "「アカウントを確認」"),
                  _createTextVNode("をタップして、Chromeブラウザを開く。")
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", { style: {"vertical-align":"top"} }, "２．"),
                _createElementVNode("td", { style: {"vertical-align":"top"} }, [
                  _createTextVNode("表示されるメッセージで"),
                  _createElementVNode("b", null, "「許可する」"),
                  _createTextVNode("をタップする。")
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", { style: {"vertical-align":"top"} }, "３．"),
                _createElementVNode("td", { style: {"vertical-align":"top"} }, "CCS HOMEアプリを開き、お子様のIDとパスワード登録画面が表示される。")
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", { style: {"vertical-align":"top"} }, "４．"),
                _createElementVNode("td", { style: {"vertical-align":"top"} }, "登録を進める。")
              ])
            ])
          ]),
          _createElementVNode("br"),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, "【メールが届かない場合】")
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, "迷惑メールフォルダ"),
            _createTextVNode("などに自動で振り分けられてないかご確認ください。")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            onClick: _ctx.reSignIn,
            color: "primary",
            block: ""
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" ログイン ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            onClick: _ctx.logout,
            color: "primary",
            outlined: "",
            block: ""
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" 別のアカウントで再度ログイン ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}